import {CompanySignup} from '../core/company-signup';
import {DOM} from '../core/dom';
import {CompaniesFAQ} from '../partials/companies_faq';
import {CompaniesMatching} from '../partials/companies_matching';
import {CompaniesCallToAction} from '../partials/company_call_to_action';
import {FreelancerCategories} from '../partials/freelancer_categories';
import {Intro} from '../partials/intro';
import { CategoriesData } from '../core/categoriesData';
import { Testemonials } from '../partials/testemonials';

DOM.onReady(() => {
  FreelancerCategories.onload('compact', CategoriesData.getCompanyRoles());
  Testemonials.onload();
  CompaniesFAQ.onload();
  CompaniesMatching.onload();
  CompaniesCallToAction.onload();
  Intro.onload('company', CompanySignup.display);
  Intro.contactUs('company', () => DOM.redirectTo('/contact.html?mode=company'))
});